'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('HubStyleTokens/colors');

var _PromptablePropInterface = require('UIComponents/decorators/PromptablePropInterface');

var _PromptablePropInterface2 = _interopRequireDefault(_PromptablePropInterface);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _connectedUpgradeDataPropsInterface = require('ui-addon-upgrades/_core/common/data/upgradeData/interfaces/connectedUpgradeDataPropsInterface');

var _submitPql = require('ui-addon-upgrades/_core/pql/submitPql');

var _RepTypes = require('ui-addon-upgrades/_core/common/constants/RepTypes');

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var Tracker = _interopRequireWildcard(_tracker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TRUSTED_DOMAINS = ['https://www.hubspot.com', 'https://hubspot.com', 'https://app.hubspot.com', 'https://meetings.hubspot.com'];

var sourceSuffix = '-iscfallback';

var MeetingModal = function (_React$Component) {
  _inherits(MeetingModal, _React$Component);

  function MeetingModal(props) {
    _classCallCheck(this, MeetingModal);

    var _this = _possibleConstructorReturn(this, (MeetingModal.__proto__ || Object.getPrototypeOf(MeetingModal)).call(this, props));

    _this.handleMessages = _this.handleMessages.bind(_this);
    return _this;
  }

  _createClass(MeetingModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.handleMessages);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleMessages);
    }
  }, {
    key: 'handleMessages',
    value: function handleMessages(e) {
      var isKnownOrigin = TRUSTED_DOMAINS.includes(e.origin);
      var upgradeData = this.props.upgradeData;

      var hasAssignedSalesRep = Boolean(upgradeData.repInfo && upgradeData.repInfo.link && upgradeData.repInfo.type === _RepTypes.MARKETING_SALES);

      if (!isKnownOrigin) return;

      if (e.data.meetingBookSucceeded) {
        // Don't fire PQL if user has a MARKETING_SALES rep -- should've already been fired
        if (!hasAssignedSalesRep) {
          (0, _submitPql.submitPql)(_extends({}, upgradeData, {
            source: '' + upgradeData.source + sourceSuffix
          }));
        }

        Tracker.track('communicationMethodsInteraction', _extends({
          action: 'meeting booked successfully',
          meetingLink: this.props.meetingLink
        }, upgradeData));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onReject = _props.onReject,
          onCancel = _props.onCancel,
          _contextual = _props._contextual,
          meetingLink = _props.meetingLink;


      return _react2.default.createElement(
        _UIModal2.default,
        {
          use: 'conversational',
          size: 'auto',
          _contextual: _contextual,
          width: 900,
          onOverlayClick: function onOverlayClick() {
            onReject();
            onCancel();
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'private-upgrades-meeting-modal' },
          _react2.default.createElement(_UIDialogCloseButton2.default, {
            onClick: function onClick() {
              onReject();
              onCancel();
            },
            color: _colors.EERIE
          }),
          _react2.default.createElement('iframe', {
            id: 'meetingModal',
            title: 'Schedule a time to chat',
            width: '900',
            height: '800',
            frameBorder: '0',
            scrolling: 'no',
            marginHeight: '0',
            marginWidth: '0',
            src: meetingLink
          })
        )
      );
    }
  }]);

  return MeetingModal;
}(_react2.default.Component);

MeetingModal.propTypes = _extends({}, _PromptablePropInterface2.default, _connectedUpgradeDataPropsInterface.connectedUpgradeDataPropsInterface, {
  meetingLink: _react.PropTypes.string
});

MeetingModal.defaultProps = {
  meetingLink: null,
  onCancel: function onCancel() {}
};

exports.default = MeetingModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/MeetingModal.js
// module id = 569
// module chunks = 3 4 5